import api from "@/lib/API";

export const fetchInventory = async (params) => {
  return await api.get('/inventory', { params });
};

export const fetchInventoryMaster = async (params) => {
  return await api.get('/final-inventory/master-stock', { params });
};

export const updateInventoryItem = async (id, data) => {
  return await api.patch(`/inventory/${id}`, data);
};

export const addItem = async (data) => {
  return await api.post('/inventory', data);
};

export const createPurchase = async (data) => {
  return await api.post('/final-inventory/purchases', data);
};

export const deleteItem = async (id) => {
  return await api.delete(`/inventory/${id}`);
};

export const fetchMaterialRequests = async (params = {}) => {
  return await api.get('/final-inventory/material-requests', { params });
};

export const updateRequestStatus = async (id, status) => {
  return await api.patch(`/final-inventory/material-requests/${id}/status`, { status });
};

export const fetchMaterialReturns = async () => {
  return await api.get('/final-inventory/material-returns');
};

export const fetchPurchases = async (params) => {
  return await api.get('/final-inventory/purchases', { params });
};



export const fetchPurchaseReturns = async (params) => {
  return await api.get('/final-inventory/purchase-returns', { params });
};

export const fetchSaleReturns = async (params) => {
  return await api.get('/inventory/sale-returns', { params });
};

export const getEmptyItem = (serviceType) => ({
  name: "",
  category: "Kitchen Cabinets",
  unit: "piece",
  availableQty: 0,
  minQty: 0,
  unitPrice: 0,
  supplier: "",
  sku: "",
  itemCode: "",

  serviceType: serviceType || "verve",

  // New Purchase Entry fields
  type: "Stockable",
  brand: "",
  hsnCode: "",
  isUnique: false,
  uniqueName: "",
  hasBatchExpiry: false,
  expiryDate: "",
  barcode: "",
  description: "",
  invoiceNo: "",
  invoiceDate: new Date().toISOString().split('T')[0],
  businessUnit: "VERVE KITCHENS",
  store: "",
  rate: 0,
  quantity: 1,
  bvPoints: 0,
  taxP: 0,
  baseAmount: 0,
  discP: 0,
  discount: 0,
  taxable: 0,
  igst: 0,
  cgst: 0,
  sgst: 0,
  taxAmount: 0,
  netBill: 0,
  chargeAmount: 0,
  adjustments: 0,
  netPayment: 0,
  items: []
});

// ── Dispatch Management ──────────────────────────────────────────────────────
export const fetchSaleDispatchInfo = (id, type = 'sale') =>
  api.get(`/inventory/sales/${id}/dispatch`, { params: { type } });

export const markSaleAsReceived = (id, type = 'sale') =>
  api.patch(`/inventory/sales/${id}/dispatch/receive`, null, { params: { type } });

export const startSaleDispatch = (id, data, type = 'sale') =>
  api.patch(`/inventory/sales/${id}/dispatch/start`, data, { params: { type } });

export const confirmSaleDelivery = (id, type = 'sale') =>
  api.patch(`/inventory/sales/${id}/dispatch/deliver`, null, { params: { type } });

export const CATEGORIES = {
  verve: ["Kitchen Cabinets", "Shutters", "Hardware & Fittings", "Carcase", "Appliances", "Accessories", "Countertops"]
};

export const UNITS = ["piece", "set", "ton", "meter", "kit", "box", "roll", "litre", "kg"];
